import styled, { css } from 'styled-components';
import { IconContainer } from '../../../../ui/Input/styled';

export const fullHeightModalStyles = css`
  height: 100%;
  overflow-y: scroll;
`;

export const SelectInputWrapper = styled.div`
  > div:first-child {
    background-color: ${({ theme }) => theme.colors.background.primary};
    margin-bottom: 15px;

    &:focus-within {
      border-color: ${({ theme }) => theme.colors.systemColors.blue};
    }

    @media screen and (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
      margin: 0;
      height: 20px;
      border: none;
      background-color: inherit;

      > input {
        padding: 0;
        height: 20px;
        padding-left: 2px;
      }

      ${IconContainer} {
        top: -7px;
        right: 3px;
      }
    }
  }
`;
